import React, { useState } from 'react';
import './StageHud.css';

/** PHP-style stage chrome: red title banner + Time / How to play / Points */
export default function StageHud({
  title,
  instruction,
  timerDisplay,
  points,
  rules = [],
}) {
  const [rulesOpen, setRulesOpen] = useState(false);
  const timeLabel = String(timerDisplay || '00:00').startsWith('Time')
    ? timerDisplay
    : `Time: ${timerDisplay}`;

  return (
    <>
      <div className="ic-title-wrap">
        <h4 className="ic-title1">{title}</h4>
      </div>

      <div className="ic-hud-row">
        <div className="ic-hud-left">
          <div className="ic-timer-back">{timeLabel}</div>
        </div>
        <div className="ic-hud-right">
          <div className="ic-points-back">Points: {points ?? 0}</div>
          <button type="button" className="ic-rulebtn" onClick={() => setRulesOpen(true)}>
            How to play
          </button>
        </div>
      </div>

      {instruction ? <h4 className="ic-instruction">{instruction}</h4> : null}

      {rulesOpen && (
        <div className="ic-rules-overlay" onClick={() => setRulesOpen(false)}>
          <div
            className="ic-rules-panel"
            style={{ '--ic-rules-frame': 'url(/img/Mobile_Frame.png)' }}
            onClick={(e) => e.stopPropagation()}
          >
            <h5>How to play</h5>
            <div className="ic-rules-body">
              {rules.map((r, i) => (
                <p key={i}>
                  {i + 1}. {r}
                </p>
              ))}
            </div>
            <button type="button" className="ic-rules-close" onClick={() => setRulesOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
